import './index.less'

const QDHeader = ({ header, color = "black", style, className }) => {
  return (
    <h1 className={`qd-header-wrapper ${className || ''}`} style={{ color, ...style }}>{header}</h1>
  )
}

export default QDHeader